import { makeStyles } from '@material-ui/core/styles';
import { redesignTheme } from '../../theme';

const { colors, fonts, fontSize, spacing, breakpoints } = redesignTheme;

export const useResourceTabsStyles = makeStyles(() => ({
  tabsWrapper: {
    width: '100%',
    maxWidth: '100%',
    borderBottom: `1px solid ${colors.tabBorder}`,
    marginBottom: spacing.md,
    overflowX: 'auto',
    WebkitOverflowScrolling: 'touch',
  },
  tabsRow: {
    display: 'flex',
    alignItems: 'stretch',
    gap: spacing.sm,
    width: '100%',
    maxWidth: '50%',
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      maxWidth: '100%',
      gap: spacing.xs,
    },
  },
  tab: {
    flex: '0 1 auto',
    minWidth: 120,
    height: 48,
    padding: '8px 24px',
    border: 0,
    borderRadius: '4px 4px 0 0',
    backgroundColor: colors.tabInactive,
    color: colors.text,
    cursor: 'pointer',
    fontFamily: fonts.opensans,
    fontSize: fontSize.md,
    lineHeight: 'normal',
    whiteSpace: 'nowrap',
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      flex: '1 1 0',
      minWidth: 0,
      height: 'auto',
      minHeight: 48,
      padding: '8px 10px',
      whiteSpace: 'normal',
      textAlign: 'center',
    },
    [`@media (min-width: ${breakpoints.tablet}px)`]: {
      minWidth: 194,
      padding: '8px 80px',
    },
  },
  tabActive: {
    flex: '0 1 auto',
    minWidth: 120,
    height: 48,
    padding: '8px 24px',
    border: 0,
    borderRadius: '4px 4px 0 0',
    backgroundColor: colors.primaryDark,
    color: colors.white,
    cursor: 'pointer',
    fontFamily: fonts.opensansSemiBold,
    fontSize: fontSize.md,
    lineHeight: 'normal',
    whiteSpace: 'nowrap',
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      flex: '1 1 0',
      minWidth: 0,
      height: 'auto',
      minHeight: 48,
      padding: '8px 10px',
      whiteSpace: 'normal',
      textAlign: 'center',
    },
    [`@media (min-width: ${breakpoints.tablet}px)`]: {
      minWidth: 194,
      padding: '8px 80px',
    },
  },
}));
